(() => {
  const sections = document.querySelectorAll(".nl-include");
  if (!sections.length) return;

  sections.forEach((el) => {
    const topTargets = [
      el.querySelector(".nl-include__title"),
      el.querySelector(".nl-include__intro"),
      el.querySelector(".nl-include__label"),
    ].filter(Boolean);

    const colTitles = Array.from(
      el.querySelectorAll(".nl-include__col-title"),
    ).filter(Boolean);

    const extraTitle = el.querySelector(".nl-include__extra-title");
    const extraCols = Array.from(
      el.querySelectorAll(".nl-include__extra-col"),
    ).filter(Boolean);

    const headerTargets = [...topTargets, ...colTitles, extraTitle].filter(
      Boolean,
    );

    const items = Array.from(el.querySelectorAll(".nl-include__item"));
    const divider = el.querySelector(".nl-include__divider");
    const bottomTitle = el.querySelector(".nl-include__bottom-title");
    const products = Array.from(el.querySelectorAll(".nl-include__product"));

    const allTargets = [
      ...headerTargets,
      ...extraCols,
      ...items,
      divider,
      bottomTitle,
      ...products,
    ].filter(Boolean);

    if (!allTargets.length) return;

    if (window.gsap && window.ScrollTrigger) {
      window.gsap.registerPlugin(window.ScrollTrigger);

      if (headerTargets.length) {
        window.gsap.from(headerTargets, {
          opacity: 0,
          y: 18,
          duration: 0.8,
          ease: "power2.out",
          stagger: 0.08,
          scrollTrigger: {
            trigger: el,
            start: "top 82%",
            once: true,
          },
        });
      }

      if (items.length) {
        window.gsap.from(items, {
          opacity: 0,
          y: 16,
          duration: 0.7,
          ease: "power2.out",
          stagger: 0.06,
          scrollTrigger: {
            trigger: el.querySelector(".nl-include__grid") || el,
            start: "top 85%",
            once: true,
          },
        });
      }

      if (extraCols.length) {
        window.gsap.from(extraCols, {
          opacity: 0,
          y: 16,
          duration: 0.75,
          ease: "power2.out",
          stagger: 0.08,
          scrollTrigger: {
            trigger: el.querySelector(".nl-include__extra") || el,
            start: "top 86%",
            once: true,
          },
        });
      }

      if (divider) {
        window.gsap.from(divider, {
          opacity: 0,
          scaleX: 0,
          transformOrigin: "left center",
          duration: 0.8,
          ease: "power2.out",
          scrollTrigger: {
            trigger: divider,
            start: "top 90%",
            once: true,
          },
        });
      }

      if (bottomTitle) {
        window.gsap.from(bottomTitle, {
          opacity: 0,
          y: 18,
          duration: 0.8,
          ease: "power2.out",
          scrollTrigger: {
            trigger: bottomTitle,
            start: "top 90%",
            once: true,
          },
        });
      }

      if (products.length) {
        window.gsap.from(products, {
          opacity: 0,
          y: 24,
          duration: 0.85,
          ease: "power2.out",
          stagger: 0.1,
          scrollTrigger: {
            trigger: el.querySelector(".nl-include__products") || el,
            start: "top 88%",
            once: true,
          },
        });
      }

      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          allTargets.forEach((target, i) => {
            target.style.opacity = "0";
            target.style.transform = "translateY(16px)";
            target.style.transition = "opacity .6s ease, transform .6s ease";
            target.style.transitionDelay = `${i * 60}ms`;

            if (target.classList.contains("nl-include__divider")) {
              target.style.transform = "scaleX(0)";
              target.style.transformOrigin = "left center";
              target.style.transition = "opacity .6s ease, transform .8s ease";
            }

            requestAnimationFrame(() => {
              target.style.opacity = "1";
              target.style.transform = target.classList.contains(
                "nl-include__divider",
              )
                ? "scaleX(1)"
                : "translateY(0)";
            });
          });

          io.unobserve(el);
        });
      },
      { threshold: 0.15 },
    );

    io.observe(el);
  });
})();
